import { render, staticRenderFns } from "./modularChild9.vue?vue&type=template&id=ba97ed98&scoped=true"
import script from "./modularChild9.vue?vue&type=script&lang=js"
export * from "./modularChild9.vue?vue&type=script&lang=js"
import style0 from "./modularChild9.vue?vue&type=style&index=0&id=ba97ed98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba97ed98",
  null
  
)

export default component.exports